// extracted by mini-css-extract-plugin
export default {"OneNewImg":"OneNewImg_OneNewImg__z9qoU","MainImg":"OneNewImg_MainImg__ldqns","SmallImg":"OneNewImg_SmallImg__qN+qf"};